import { render, staticRenderFns } from "./SOVDetailReport.vue?vue&type=template&id=4db06510&scoped=true"
import script from "./SOVDetailReport.vue?vue&type=script&lang=js"
export * from "./SOVDetailReport.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailReport.vue?vue&type=style&index=0&id=4db06510&prod&lang=css"
import style1 from "./SOVDetailReport.vue?vue&type=style&index=1&id=4db06510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db06510",
  null
  
)

export default component.exports